var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcNovice(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1044",
    "data-name": "Rectangle 1044",
    width: 41.973,
    height: 37.985,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ic_novice",
    transform: "translate(-328.833 -215.421)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_49",
    "data-name": "Ellipse 49",
    cx: 25,
    cy: 25,
    r: 25,
    transform: "translate(328.833 215.421)",
    fill: "rgba(195,230,255,0)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_171",
    "data-name": "Group 171",
    transform: "translate(332.847 220.292)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_171-2",
    "data-name": "Group 171",
    transform: "translate(0 0)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_21718",
    "data-name": "Path 21718",
    d: "M36.877,14.045a3.777,3.777,0,0,0-1.983.571,14.654,14.654,0,0,0-28.856,0,3.81,3.81,0,1,0,.256,6.314,14.652,14.652,0,0,0,28.344,0,3.771,3.771,0,0,0,2.239.739,3.812,3.812,0,1,0,0-7.623",
    transform: "translate(0.519 5.354)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21719",
    "data-name": "Path 21719",
    d: "M36.526,14.316a4.34,4.34,0,0,0-.461.243c-.025-.147-.065-.284-.1-.427a3.732,3.732,0,0,0-.979-.143,3.774,3.774,0,0,0-1.98.571,14.666,14.666,0,0,0-12.9-12,14.663,14.663,0,0,0-12.9,12,3.777,3.777,0,0,0-1.983-.571,3.771,3.771,0,0,0-.979.143c-.028.143-.069.281-.094.427a4.34,4.34,0,0,0-.461-.243,3.8,3.8,0,0,0-.009,6.965,3.777,3.777,0,0,0,.726-.408c.059.231.137.452.209.68a3.9,3.9,0,0,0,.608.059,3.771,3.771,0,0,0,2.239-.739A14.667,14.667,0,0,0,20.108,31.719,14.663,14.663,0,0,0,32.751,20.872a3.771,3.771,0,0,0,2.239.739,3.863,3.863,0,0,0,.608-.059c.072-.228.15-.449.209-.68a3.711,3.711,0,0,0,.73.408,3.806,3.806,0,0,0-.009-6.965",
    transform: "translate(2.993 5.411)",
    fill: "#ffe5e3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21720",
    "data-name": "Path 21720",
    d: "M4.444,8.169A1.623,1.623,0,1,1,6.065,9.794,1.623,1.623,0,0,1,4.444,8.169",
    transform: "translate(9.412 13.862)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21721",
    "data-name": "Path 21721",
    d: "M7.976,8.169A1.624,1.624,0,1,1,9.6,9.794,1.623,1.623,0,0,1,7.976,8.169",
    transform: "translate(16.892 13.862)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21722",
    "data-name": "Path 21722",
    d: "M20.986,33.15A15.436,15.436,0,0,1,6.354,22.587a4.516,4.516,0,0,1-1.78.368,4.577,4.577,0,0,1,0-9.154,4.506,4.506,0,0,1,1.434.237,15.42,15.42,0,0,1,29.956,0A4.5,4.5,0,0,1,37.4,13.8a4.577,4.577,0,0,1,0,9.154,4.516,4.516,0,0,1-1.78-.368A15.429,15.429,0,0,1,20.986,33.15M7.268,20.17l.287,1.085a13.885,13.885,0,0,0,26.863,0L34.7,20.17l.9.661a3.016,3.016,0,0,0,1.79.6,3.049,3.049,0,0,0,0-6.1,2.991,2.991,0,0,0-1.581.458l-.957.583-.2-1.1a13.889,13.889,0,0,0-27.35,0l-.2,1.1-.957-.583a3,3,0,0,0-1.584-.458,3.049,3.049,0,0,0,0,6.1,3.009,3.009,0,0,0,1.79-.6Z",
    transform: "translate(0 4.835)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21723",
    "data-name": "Path 21723",
    d: "M7.857,8.169l-.5-.574A4.7,4.7,0,0,1,7.8.967a3.9,3.9,0,0,1,5.515.374A3.275,3.275,0,0,1,13,5.968l-.574.5-1.007-1.15.577-.5a1.75,1.75,0,0,0,.165-2.472,2.363,2.363,0,0,0-1.634-.811,2.39,2.39,0,0,0-1.724.583,3.165,3.165,0,0,0-.3,4.471l.5.574Z",
    transform: "translate(13.117 0)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21724",
    "data-name": "Path 21724",
    d: "M5.2,13.649a4.773,4.773,0,1,1,4.773,4.773A4.772,4.772,0,0,1,5.2,13.649",
    transform: "translate(11.013 18.798)",
    fill: "#4b89c6"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21725",
    "data-name": "Path 21725",
    d: "M10.492,19.706a5.537,5.537,0,1,1,5.537-5.537,5.545,5.545,0,0,1-5.537,5.537m0-9.547a4.01,4.01,0,1,0,4.01,4.01,4.015,4.015,0,0,0-4.01-4.01",
    transform: "translate(10.494 18.28)",
    fill: "#404040"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21726",
    "data-name": "Path 21726",
    d: "M6.2,11.538A1.663,1.663,0,1,1,7.862,13.2,1.665,1.665,0,0,1,6.2,11.538",
    transform: "translate(13.124 20.91)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_21727",
    "data-name": "Path 21727",
    d: "M8.381,14.483a2.427,2.427,0,1,1,2.426-2.426,2.429,2.429,0,0,1-2.426,2.426m0-3.327a.9.9,0,1,0,.9.9.9.9,0,0,0-.9-.9",
    transform: "translate(12.606 20.391)",
    fill: "#fff"
  }))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcNovice);
export default __webpack_public_path__ + "static/media/ic_novice.d7a81d32eea1f4da5d1045b97ae5ff1e.svg";
export { ForwardRef as ReactComponent };